module.exports = __webpack_public_path__ + "img/shipo-icon-award.21c339c3.svg";